<template>
  <b-modal
    ref="modal-dashboard-attendance-today"
    hide-footer
    size="sm"
    @hidden="onlyClose"
  >
    <template #modal-header>
      <div class="d-flex justify-content-center h5" style="width: 100%">
        {{ dataModal.fullDate | myDateGlobal }}
      </div>
    </template>
    <template #default>
      <b-form-group
        :label="$t('description') | capitalize"
        label-for="to"
        style="width: 100%"
      >
        <b-form-input id="comment" v-model="attendance.description" disabled />
      </b-form-group>
      <b-form-group
        :label="$t('observation') | capitalize"
        label-for="to"
        style="width: 100%"
      >
        <b-form-input id="comment" v-model="attendance.observation" disabled />
      </b-form-group>
      <b-form-group
        :label="$t('comment') | capitalize"
        label-for="to"
        style="width: 100%"
      >
        <b-form-textarea
          id="comment"
          v-model="attendance.comment"
          disabled
          v-uppercase
        />
      </b-form-group>
      <validation-observer ref="form">
        <b-form-group
          :label="$t('driver comment') | capitalize"
          label-for="to"
          style="width: 100%"
        >
          <validation-provider v-slot="{ errors }" rules="required">
            <b-form-textarea
              id="comment"
              class="input-form observer"
              :class="{ 'border-danger': errors[0] }"
              no-resize
              size="lg"
              v-model="attendance.driver_comment"
              :disabled="haveComment"
            />
          </validation-provider>
        </b-form-group>
        <div class="d-flex justify-content-end" style="width: 100%">
          <b-button variant="outline-danger" size="sm" @click="onlyClose">
            {{ $t("close") | capitalize }}
          </b-button>
          <b-button
            variant="outline-primary"
            class="ml-1"
            size="sm"
            @click="saveDriverComment"
            v-if="!haveComment"
          >
            {{ $t("SAVE") | capitalize }}
          </b-button>
        </div>
      </validation-observer>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import modalMixin from "@/mixins/modal";
import DashboardService from "@/views/driver/views/dashboard/services/dashboard.service.js";
import AttendanceService from "@/views/monitoring/views/attendance/services/attendance.service.js";
export default {
  mixins: [modalMixin],
  props: {
    dataModal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showModalDetail: true,
      attendance: {
        abbreviation: "",
        description: "",
      },
      driverComment: null,
      haveComment: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  mounted() {
    this.toggleModal("modal-dashboard-attendance-today");
  },
  async created() {
    await this.getAttendanceByDay();
  },
  methods: {
    onlyClose() {
      this.$emit("onlyClose");
    },

    async getAttendanceByDay() {
      try {
        this.addPreloader();
        const params = {
          id: this.dataModal.id,
        };
        const { data } = await DashboardService.getAttendanceByDay(params);
        this.attendance = data[0];
        this.haveComment =
          data[0].driver_comment != null && data[0].driver_comment != "";
      } catch (error) {
        this.showToastError();
      } finally {
        this.removePreloader();
      }
    },

    async saveDriverComment() {
      const isValidMessage = await this.$refs.form.validate();
      if (isValidMessage) {
        try {
          this.addPreloader();
          const params = {
            id: this.dataModal.id,
            user_id: this.currentUser.id,
            driver_comment: this.attendance.driver_comment,
          };
          const { data } = await AttendanceService.saveDriverComment(params);
          this.$emit("commentSent");
          this.showToastSuccess(
            "THE COMMENT WAS SENT TO THE SUPERVISOR",
            "COMMENT SENT"
          );
        } catch (error) {
          console.log(error);
          this.showToastError();
        } finally {
          this.onlyClose();
          this.removePreloader();
        }
      }
    },
  },
};
</script>

<style>
</style>